import React from 'react';
import {IFormFieldDesignContext} from '../@interfaces/contexts/IFormFieldDesignContext';

export const defaultValue: IFormFieldDesignContext = {
    size: undefined,
    wrapperClass: '',
    errorMessageContainerClass: 'invalid-feedback',
    fieldsAreDisabled: false,
    fieldsAreReadOnly: false,
};

export type FormFieldDesign = [
    IFormFieldDesignContext,
    React.Dispatch<React.SetStateAction<IFormFieldDesignContext>>
];

export const FormFieldDesignContext = React.createContext<FormFieldDesign>([defaultValue, (prevState) => prevState]);
